import { useProtected } from "@/hooks";
import { Outlet } from "react-router-dom";

export const SubscriptionRoot = () => {
  useProtected();
  return <Outlet />;
};

export { NewSubscriptionPage } from "./NewSubscription";
export { CheckoutPage } from "./Checkout";
export { ReturnPage } from "./Return";
